import DOMPurify from "dompurify";

// Sanitize server/LLM-generated SVG before rendering via dangerouslySetInnerHTML.
// Uses DOMPurify's SVG profile (blocks <script>, event handlers, javascript: URLs,
// <foreignObject>, external xlink:href, etc.) instead of brittle regex stripping.
export const sanitizeSvg = (svg) =>
  DOMPurify.sanitize(svg || "", {
    USE_PROFILES: { svg: true, svgFilters: true },
    ADD_TAGS: ["use"],
  });
